import {
  CommonVodPageType,
  MakingPlaylistQueryModel,
  VodListQueryModel,
} from '@/types/channel/vod/vod.model';
import {MakingPlaylistQueryParams} from '@/types/channel/vod/vod.schema';

export const VOD_LIST_PREFIX = 'vodList';

// TODO: 게시글쪽 함수도 함께 묶어서 util로 빼내기 (여유될때)
/**
 * VOD 목록 쿼리 키 생성 함수
 * @param userId - 사용자 ID
 * @param vodType - 조회하려는 VOD 유형
 * @param params - 게시글 목록 조회 파라미터 (선택사항)
 * @returns 쿼리 키 배열
 */
export const createVodListQueryKey = (
  userId: string,
  vodType?: CommonVodPageType,
  params?: Partial<VodListQueryModel>,
) => {
  const baseKey = [VOD_LIST_PREFIX, userId];

  if (!params) {
    return baseKey;
  }

  // 실제로 존재하는 값들만 필터링하여 쿼리 키에 추가
  const validParams: Record<string, any> = {};

  if (params.search !== undefined && params.search !== '') {
    validParams.search = params.search;
  }

  if (params.sort !== undefined) {
    validParams.sort = params.sort;
  }

  if (params.period !== undefined) {
    validParams.period = params.period;
  }

  if (params.startDate !== undefined && params.startDate !== '') {
    validParams.startDate = params.startDate;
  }

  if (params.endDate !== undefined && params.endDate !== '') {
    validParams.endDate = params.endDate;
  }

  if (params.createdBy !== undefined) {
    validParams.createdBy = params.createdBy;
  }

  if (params.page !== undefined) {
    validParams.page = params.page;
  }

  if (params.perPage !== undefined) {
    validParams.perPage = params.perPage;
  }

  // 유효한 파라미터가 있는 경우에만 추가
  return Object.keys(validParams).length > 0
    ? [...baseKey, vodType, validParams]
    : baseKey;
};

export const PLAYLIST_LIST_PREFIX = 'playlistList';

export const VOD_LIST_QUERY_KEY = {
  /** VOD(캐치 포함) 조회 시 사용하는 쿼리 키를 생성합니다. */
  VOD_LIST: (
    userId: string,
    vodType?: CommonVodPageType,
    params?: Partial<VodListQueryModel>,
  ) => createVodListQueryKey(userId, vodType, params),
  PLAYLIST_LIST: (
    id: MakingPlaylistQueryModel['id'],
    userId: MakingPlaylistQueryModel['userId'],
    sort: MakingPlaylistQueryModel['sort'],
  ) => [PLAYLIST_LIST_PREFIX, id, userId, sort],
};
